var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "bs-table-custom-toolbar",
          attrs: { id: "projectsToolbar" },
        },
        [
          _c(
            "c-switch",
            _vm._b(
              {
                staticStyle: {
                  "margin-left": "1rem",
                  "margin-right": "0.5rem",
                },
                attrs: {
                  id: "showInactiveProjects",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.showInactiveProjects,
                  callback: function ($$v) {
                    _vm.showInactiveProjects = $$v
                  },
                  expression: "showInactiveProjects",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _c("span", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.$t("message.show_inactive_projects"))),
          ]),
        ],
        1
      ),
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
        on: {
          "on-load-success": _vm.tableLoaded,
          "on-post-body": _vm.onPostBody,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }